<template>
    <heading>{{ $t('Forgot your password?') }}</heading>

    <div v-if="isFormPhase">
        <alert v-if="state.emailSent" type="success">
            {{ $t("We have sent you an email with the instructions to reset your password.") }}
        </alert>
        <div v-else>
            <p class="mb-6">
                {{ $t("Forgot your password? No problem. Just let us know your email address and we will email you a password reset link that will allow you to choose a new one.") }}
            </p>

            <form @submit.prevent="requestResetSubmit">
                <form-input v-model="requestForm.login" :error="requestForm.errors.login" class="mb-6" name="login"
                            :label="$t('Login')" icon="fa-solid fa-user"></form-input>
                <form-input v-model="requestForm.email" :error="requestForm.errors.email" class="mb-6" name="email"
                            type="email" :label="$t('Email')" icon="fa-solid fa-envelope"/>
                <btn ref="requestResetButton" :disabled="requestForm.processing">
                    {{ $t("Continue") }}
                </btn>
            </form>
        </div>
    </div>
    <div v-else>
        <form @submit.prevent="changePasswordSubmit">
            <FormInput v-model="changePasswordForm.email" :error="changePasswordForm.errors.email" :label="$t('Email')"
                       name="secret_code" icon="fa-solid fa-envelope" class="mb-6"/>
            <FormInput v-model="changePasswordForm.password" :error="changePasswordForm.errors.password" :label="$t('Password')" name="password"
                       type="password" icon="fa-solid fa-key" class="mb-6"/>
            <FormInput v-model="changePasswordForm.password_confirmation" :error="changePasswordForm.errors.password_confirmation"
                       :label="$t('Confirm password')" name="password_confirmation" icon="fa-solid fa-key"
                       type="password" class="mb-6"/>
            <FormInput v-model="changePasswordForm.token" :error="changePasswordForm.errors.token" :label="$t('Secret code')"
                       name="secret_code" icon="fa-solid fa-key" class="mb-6"/>
            <Btn ref="changePasswordButton" :disabled="changePasswordForm.processing">{{ $t("Change password") }}</Btn>
        </form>
    </div>
</template>

<script setup>
import {useForm} from "@inertiajs/inertia-vue3";
import Heading from "@/Shared/Heading";
import FormInput from "@/Shared/FormInput";
import Btn from "@/Shared/Button";
import {reactive, ref} from "vue";
import Alert from "@/Shared/Alert";

const props = defineProps({
    email: {
        type: String,
        default: null
    },
    token: {
        type: String,
        default: null
    },
})

const requestForm = useForm({
    login: null,
    email: null
})

const changePasswordForm = useForm({
    password: null,
    password_confirmation: null,
    email: props.email,
    token: props.token
})

const requestResetButton = ref(null);
const changePasswordButton = ref(null);

const isFormPhase = props.email === null && props.token === null

const state = reactive({
    emailSent: false,
})

function requestResetSubmit() {
    requestResetButton.value.toggleLoading();
    requestForm.post(route('forgot_password.request_link'), {
        preserveScroll: true,
        onSuccess: () => state.emailSent = true,
        onFinish: () => requestResetButton.value.toggleLoading()
    })
}

function changePasswordSubmit() {
    changePasswordButton.value.toggleLoading();
    changePasswordForm.post(route('forgot_password.reset_password'), {
        preserveScroll: true
    })
}
</script>
